import { render, staticRenderFns } from "./jd-select-muti.vue?vue&type=template&id=18f9f9d0&scoped=true&"
import script from "./jd-select-muti.vue?vue&type=script&lang=js&"
export * from "./jd-select-muti.vue?vue&type=script&lang=js&"
import style0 from "./jd-select-muti.vue?vue&type=style&index=0&id=18f9f9d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f9f9d0",
  null
  
)

export default component.exports